import Input from 'antd/es/input';
const { Password: InputPassword } = Input;

export default InputPassword;
